module.exports = __webpack_public_path__ + "img/test-monitor-image.f7a3729b.png";